import { z } from "zod";

export const AttributeSchema = z.object({
  id: z.uuid(),
  version: z.number(),
  active: z.boolean(),
  content: z.string(),
  display_content: z.string().optional(), // For applicant-conditions endpoint
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});

export const LogSchema = z.object({
  id: z.uuid(),
  description: z.string(),
  causer_id: z.uuid(),
  causer_type: z.string(),
  subject_type: z.string(),
  subject_id: z.null(),
  properties: z.object({
    attributes: AttributeSchema,
  }),
  created_at: z.iso.datetime(),
});

export const LegalSchema = z.object({
  id: z.uuid(),
  version: z.number(),
  active: z.boolean(),
  content: z.string(),
  display_content: z.string().optional(), // For applicant-conditions endpoint
  logs: z.array(LogSchema).optional(),
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});

export const UpdateLegalShema = z.object({
  id: z.uuid(),
  content: z.string(),
  active: z.boolean(),
});
